import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import scan from '../views/wechat/scan.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Login',
        component: Login,
        hidden: true
    }, {
        path: '/home',
        name: 'Home',
        component: Home,
        children: [
            {
                path: '/visualRegister',
                name: '视力信息录入',
                component: () => import( '@/views/emp/visualregister/EmpVisualRegister.vue')
            },
            {
                path:'/manageCheckListInfo',
                name:'管理学生基础信息',
                component: () => import('@/views/emp/visualregister/EmpCheckListManage.vue')
            },
            {
                path:'/expReport',
                name:'导出视力报告',
                component: ()=> import('@/views/emp/visualregister/EmpReport')
            },


            {
                path:'/eyesightEdit',
                name:'编辑视力信息',
                component:() => import('@/views/emp/visualregister/EmpEyesightEdit.vue')
            }
        ]
    }, {
        path: '/scan',
        name: 'scan',
        component: scan,
        hidden: true
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
